module.exports = __webpack_public_path__ + "static/media/as400.356a3851.jpg";